module.exports = __webpack_public_path__ + "img/pin-diamante.1d7a4b7a.png";